export default __webpack_public_path__ + "static/media/IMG_7591.b7f1260a.jpeg";